import { useState } from "react";
import { useHistory } from "react-router-dom";
import chef from "../../assets/IMG_5264.jpg";
import { POST_USER_DATA } from "../../store/action";
import { t } from "../../translations";
import { POST } from "../constants/request-type";
import { service_api } from "../constants/url";
import "../styles/pani-empowerment.css";
import { openNotificationWithIcon } from "./notification-bar";

import {
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { createLogger } from "../../utils/logger";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

const logger = createLogger("PaniEmpowerment");
const PaniEmpowerment = (props) => {
  const history = useHistory();
  const [accept, setAccept] = useState(false);
  const [registrationType, setRegistrationType] = useState("chef"); // "chef" or "restaurant" - default to "chef"
  const [loading, setLoading] = useState(false);
  const [showOtpStep, setShowOtpStep] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);

  const { phone, setPhone } = props;

  const user = useSelector((state) => state.user);
  const lang = useSelector((state) => state.lang);

  const title = t("pani_empowerment.earn_more_money", lang);
  const text = t("pani_empowerment.put_meals_description", lang);

  const dispatch = useDispatch();

  const post_user_data = (data) => {
    dispatch(post_user(data));
  };

  const sendOtp = async () => {
    const request_details = {
      type: POST,
      url: service_api,
      route: "user/send-chef-otp",
      data: {
        number: phone,
        userId: user?._id,
        registrationType: registrationType
      },
      token: user?.refresh_token
    };

    try {
      await MakeRequestAsync(request_details);
      setLoading(false);
      setShowOtpStep(true);
      openNotificationWithIcon(
        "success",
        t("pani_empowerment.otp_sent_success", lang)
      );
    } catch (err) {
      setLoading(false);
      logger.log("Error sending OTP: ", err?.response?.data?.message);
      openNotificationWithIcon(
        "error",
        err?.response?.data?.message ||
          t("pani_empowerment.sms_send_error", lang)
      );
    }
  };

  const verifyOtpAndBecomeChef = async () => {
    const request_details = {
      type: POST,
      url: service_api,
      route: "user/verify-chef-otp",
      data: {
        number: phone,
        otp: otp,
        userId: user?._id,
        registrationType: registrationType
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      setOtpLoading(false);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
      const successMessage =
        registrationType === "restaurant"
          ? t("pani_empowerment.restaurant_verification_success", lang)
          : t("pani_empowerment.chef_verification_success", lang);

      openNotificationWithIcon("success", successMessage);

      setTimeout(() => {
        // For now, both chef and restaurant redirect to the same chef home
        // TODO: Update redirect path for restaurants if a separate route is needed
        history.push("/chef/iam-a-chef/home");
      }, 1500);
    } catch (err) {
      setOtpLoading(false);
      logger.log("Error verifying OTP: ", err?.response?.data?.message);
      openNotificationWithIcon(
        "error",
        err?.response?.data?.message ||
          t("pani_empowerment.invalid_otp_error", lang)
      );
    }
  };

  const resendOtp = async () => {
    setOtpLoading(true);
    await sendOtp();
    setOtpLoading(false);
  };

  return (
    <div className="pani-empowerment">
      <section class="passion-section">
        <h2 style={{ fontWeight: "600" }}>{title}</h2>
        <p>{text}</p>
        <div class="form-container">
          <input
            type="number"
            placeholder={t("pani_empowerment.enter_phone_placeholder", lang)}
            name="phone"
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            value={phone}
          />
          <button
            onClick={async () => {
              if (user === null) {
                return openNotificationWithIcon(
                  "error",
                  t("pani_empowerment.must_login_before", lang)
                );
              }
              if (!phone || phone.length < 7) {
                return openNotificationWithIcon(
                  "error",
                  t("pani_empowerment.must_fill_valid_contact", lang)
                );
              }
              if (!registrationType) {
                return openNotificationWithIcon(
                  "error",
                  t("pani_empowerment.must_select_registration_type", lang)
                );
              }
              if (!accept) {
                return openNotificationWithIcon(
                  "error",
                  t("pani_empowerment.must_accept_terms", lang)
                );
              }
              setLoading(true);
              await sendOtp();
            }}
            disabled={loading}
          >
            {!loading && t("pani_empowerment.start", lang)}
            {loading && <CircularProgress size={20} color="inherit" />}
          </button>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "20px",
            marginBottom: "20px"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <input
              type="radio"
              id="register-chef"
              name="registration-type"
              value="chef"
              checked={registrationType === "chef"}
              onChange={(e) => {
                setRegistrationType(e.target.value);
              }}
            />
            <label
              htmlFor="register-chef"
              style={{
                fontSize: 16,
                fontWeight: 500,
                cursor: "pointer"
              }}
            >
              {t("pani_empowerment.register_as_chef", lang)}
            </label>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <input
              type="radio"
              id="register-restaurant"
              name="registration-type"
              value="restaurant"
              checked={registrationType === "restaurant"}
              onChange={(e) => {
                setRegistrationType(e.target.value);
              }}
            />
            <label
              htmlFor="register-restaurant"
              style={{
                fontSize: 16,
                fontWeight: 500,
                cursor: "pointer"
              }}
            >
              {t("pani_empowerment.register_as_restaurant", lang)}
            </label>
          </div>
        </div>
        <div class="terms">
          <input
            type="checkbox"
            id="terms-checkbox"
            checked={accept}
            onChange={() => {
              setAccept(!accept);
            }}
          />
          <label
            for="terms-checkbox"
            style={{
              fontSize: 16,
              fontWeight: 700
            }}
          >
            {t("pani_empowerment.accept_the", lang)}{" "}
            <a href="/privacy-policy">
              {t("pani_empowerment.terms_and_conditions", lang)}
            </a>{" "}
            {t("pani_empowerment.general_terms_privacy", lang)}
          </label>
        </div>
      </section>
      <img src={chef} alt="" />

      {/* OTP Verification Dialog */}
      <Dialog
        open={showOtpStep}
        onClose={() => setShowOtpStep(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "16px",
            padding: "10px"
          }
        }}
      >
        <DialogTitle style={{ textAlign: "center", paddingBottom: "10px" }}>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#333",
              marginBottom: "10px"
            }}
          >
            {t("pani_empowerment.enter_verification_code", lang)}
          </div>
          <div style={{ fontSize: "16px", color: "#666", fontWeight: "400" }}>
            {t("pani_empowerment.verification_code_sent_to", lang)} {phone}
          </div>
        </DialogTitle>

        <DialogContent style={{ textAlign: "center", paddingTop: "10px" }}>
          {/* OTP Banner */}

          {/* OTP Input Fields */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              marginBottom: "30px"
            }}
          >
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <input
                key={index}
                type="number"
                maxLength="1"
                value={otp[index] || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 1 && /^\d*$/.test(value)) {
                    const newOtp = otp.split("");
                    newOtp[index] = value;
                    setOtp(newOtp.join(""));

                    // Auto-focus next input
                    if (value && index < 5) {
                      const nextInput =
                        e.target.parentElement.children[index + 1];
                      if (nextInput) nextInput.focus();
                    }
                  }
                }}
                onKeyDown={(e) => {
                  // Handle backspace to focus previous input
                  if (e.key === "Backspace" && !otp[index] && index > 0) {
                    const prevInput =
                      e.target.parentElement.children[index - 1];
                    if (prevInput) prevInput.focus();
                  }
                }}
                style={{
                  width: "50px",
                  height: "60px",
                  textAlign: "center",
                  fontSize: "24px",
                  fontWeight: "600",
                  border: "2px solid #e0e0e0",
                  borderRadius: "12px",
                  outline: "none",
                  transition: "border-color 0.2s",
                  backgroundColor: "#fafafa"
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#e91e63";
                  e.target.style.backgroundColor = "#fff";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.backgroundColor = "#fafafa";
                }}
              />
            ))}
          </div>

          <div
            style={{ fontSize: "14px", color: "#999", marginBottom: "20px" }}
          >
            {t("pani_empowerment.enter_6_digit_code", lang)}
          </div>
        </DialogContent>

        <DialogActions
          style={{ flexDirection: "column", padding: "0 24px 24px" }}
        >
          <button
            onClick={async () => {
              if (!otp || otp.length !== 6) {
                return openNotificationWithIcon(
                  "error",
                  t("pani_empowerment.enter_6_digit_code_error", lang)
                );
              }
              setOtpLoading(true);
              await verifyOtpAndBecomeChef();
            }}
            disabled={otpLoading}
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "10px",
              backgroundColor: "#e91e63",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: otpLoading ? "not-allowed" : "pointer"
            }}
          >
            {!otpLoading && t("pani_empowerment.verify_code_button", lang)}
            {otpLoading && <CircularProgress size={20} color="inherit" />}
          </button>

          <button
            onClick={resendOtp}
            disabled={otpLoading}
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "10px",
              backgroundColor: "transparent",
              color: "#e91e63",
              border: "2px solid #e91e63",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: otpLoading ? "not-allowed" : "pointer"
            }}
          >
            {t("pani_empowerment.resend_button", lang)}
          </button>

          <button
            onClick={() => {
              setShowOtpStep(false);
              setOtp("");
            }}
            style={{
              width: "100%",
              padding: "8px",
              backgroundColor: "transparent",
              color: "#666",
              border: "none",
              textDecoration: "underline",
              fontSize: "14px",
              cursor: "pointer"
            }}
          >
            {t("pani_empowerment.change_phone_button", lang)}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PaniEmpowerment;

const post_user = (data) => ({
  type: POST_USER_DATA,
  data: data
});
